export enum MarketStatus {
    Active = 'active',
    Inactive = 'inactive',
}